import { render, staticRenderFns } from "./GDefaultTemplateMenu.vue?vue&type=template&id=6e3cd0d6&scoped=true&"
import script from "./GDefaultTemplateMenu.vue?vue&type=script&lang=ts&"
export * from "./GDefaultTemplateMenu.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3cd0d6",
  null
  
)

export default component.exports